import { BarChartResultResponse } from '@business/entities/dashboard';
import 'chartist/dist/scss/chartist.scss';
import React, { memo, useMemo } from 'react';
import { Card, CardTitle } from 'reactstrap';
import { WidgetProps } from '../types';
import { WidgetIcons } from '../BaseWidget';
import { R } from '@core/utils/r';
import ReactEcharts from 'echarts-for-react';
import { FunnelWidgetConfigData } from './FunnelWidgetConfig';

export const FunnelWidget = memo((props: WidgetProps<BarChartResultResponse, FunnelWidgetConfigData>) => {
  const { settings, result, config } = props;

  const data = useMemo(() => {
    if (!result) {
      return [
        { value: 60, name: 'Visit' },
        { value: 40, name: 'Inquiry' },
        { value: 20, name: 'Order' },
        { value: 80, name: 'Click' },
        { value: 100, name: 'Show' },
      ];
    }
    return result.labels.map((label, index) => ({
      value: result.series[index],
      name: label,
    }));
  }, [result]);
  const options = {
    legend: {
      data: result ? result.labels : ['Show', 'Click', 'Visit', 'Inquiry', 'Order'],
    },
    tooltip: {
      trigger: 'item',
      formatter: (data: any) => `${data.name}: ${data.value} (${Math.round(data.percent)}%)`,
    },
    label: {
      formatter: '{b}: {c}',
    },
    series: [
      {
        sort: config?.sort || 'descending',
        type: 'funnel',
        width: '70%',
        labelLine: {
          show: false,
        },
        itemStyle: {
          borderColor: '#fff',
          borderWidth: 1,
        },
        data,
      },
    ],
  };

  return (
    <Card className="p-4" style={{ marginBottom: 0, flex: 1 }}>
      <CardTitle className="mb-4 d-flex align-items-center flex-row">
        {settings.title || 'Funnel'} <WidgetIcons {...props} />
      </CardTitle>
      <div className="e-chart d-flex" style={{ flexGrow: 1, height: '100%' }}>
        <ReactEcharts style={{ height: '100%', width: '100%' }} option={options} />
      </div>
    </Card>
  );
});
